import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export function Footer() {
  const { t, L } = useLang();
  return (
    <footer className="mt-24 border-t-4 border-black bg-[#111111] text-white">
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="font-display text-3xl mb-3">放空生活集</div>
          <p className="text-white/70 text-sm max-w-xs leading-relaxed">
            {L("一个长期举办、不断生长的生活市集。", "A long-running, ever-growing lifestyle market.")}
          </p>
        </div>
        <div className="text-sm space-y-2">
          <div className="font-mono-fk text-[#FFD93D] mb-3">{t("nav_home")}</div>
          <Link to="/about" className="block hover:text-[#00E5FF]">{t("nav_about")}</Link>
          <Link to="/markets" className="block hover:text-[#00E5FF]">{t("nav_markets")}</Link>
          <Link to="/workshops" className="block hover:text-[#00E5FF]">{t("nav_workshops")}</Link>
          <Link to="/vendors" className="block hover:text-[#00E5FF]">{t("nav_vendors")}</Link>
        </div>
        <div className="space-y-3">
          <div className="font-mono-fk text-[#FFD93D]">{t("contact")}</div>
          <div className="flex gap-3">
            <a href="https://wa.me/60123456789" target="_blank" rel="noreferrer" className="fk-border border-white rounded-full p-2.5 hover:bg-[#00E5FF] hover:text-black hover:border-[#00E5FF] transition-colors" aria-label="WhatsApp"><MessageCircle size={18} /></a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="fk-border border-white rounded-full p-2.5 hover:bg-[#FF5757] hover:border-[#FF5757] transition-colors" aria-label="Instagram"><Instagram size={18} /></a>
            <a href="mailto:hello@fangkong.market" className="fk-border border-white rounded-full p-2.5 hover:bg-[#FFD93D] hover:text-black hover:border-[#FFD93D] transition-colors" aria-label="Email"><Mail size={18} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-white/50 text-xs font-mono-fk">
        © 2026 放空生活集 FANGKONG LIFE MARKET
      </div>
    </footer>
  );
}
